import { render } from "./DocusignEmbed.vue?vue&type=template&id=a25fae5a"
import script from "./DocusignEmbed.vue?vue&type=script&lang=js"
export * from "./DocusignEmbed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__